import React, { Dispatch, FC, SetStateAction, SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";

import { Tabs } from "@components/common";

export type Tab =
  | "overview"
  | "sustainability-topics"
  | "governance"
  | "environment"
  | "social";

export const tabs: {
  title: string;
  path: Tab;
  pageId: string;
  reportId?: string;
}[] = [
  {
    title: "vsme.hub.dashboard.report.overview",
    path: "overview",
    pageId: "ReportSection26e61161ba67f1b35b4b",
  },
  {
    title: "vsme.hub.dashboard.report.sustainabilityTopics",
    path: "sustainability-topics",
    pageId: "ReportSectionfd69324ccf5b882732a0",
  },
  {
    title: "vsme.hub.dashboard.report.governance",
    path: "governance",
    pageId: "ReportSection05d8e1a6039009ee5bd7",
  },
  {
    title: "vsme.hub.dashboard.report.environment",
    path: "environment",
    pageId: "ReportSection98989a039c6a4d1dacfa",
  },
  {
    title: "vsme.hub.dashboard.report.social",
    path: "social",
    pageId: "ReportSection98989a039c6a4d1dacfb",
  },
];

interface Component {
  activeTab: Tab;
  setActiveTab: Dispatch<SetStateAction<Tab>>;
}

const Component: FC<Component> = ({ activeTab, setActiveTab }) => {
  const handleTabChange = (event: SyntheticEvent, value: Tab): void => {
    setActiveTab(value);
  };
  const { t } = useTranslation();

  return (
    <Tabs<Tab>
      tabs={tabs.map((tab) => ({ title: t(tab.title), path: tab.path }))}
      activeTab={(activeTab as Tab) || "overview"}
      onChange={handleTabChange}
    />
  );
};

export default Component;
